/* eslint-disable import/no-named-as-default */

/* eslint-disable no-use-before-define */

/* eslint-disable no-return-await */
// #region Imports
import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@material-ui/core/Box';

import ENDPOINTS from '../../consts/endpoints';
import ScreenLoader from '../../containers/ScreenLoader';
import api from '../../library/api';
import { authBBSeg } from '../../library/authorization';
import { getParameterByName } from '../../library/utils';

// #endregion

function LoginOAuthBB() {
  const handleLoader = useRef();
  const navigate = useNavigate();

  const handleToken = useCallback(async () => {
    let token = getParameterByName('token');
    const code = authBBSeg();

    if (!token) {
      handleLoader.current.handleControl();

      if (code) {
        token = await getToken(code);
      } else {
        navigate('/home');
      }
    }

    if (token) {
      localStorage.clear();

      window.location.href = ENDPOINTS.PORTAL_BB_SEGUROS(
        encodeURIComponent(token),
      );
    }
  }, [navigate]);

  useEffect(() => {
    handleToken();
  }, [handleToken]);

  const getToken = async (code) => {
    const url = ENDPOINTS.GET_TOKEN(code);

    return await api
      .get(url)
      .then((response) => {
        return response.data.token;
      })
      .catch((error) => {
        return error;
      });
  };

  return (
    <>
      <Box height="100vh" width="100vw" bgcolor="#fae128" />
      <ScreenLoader ref={handleLoader} />
    </>
  );
}

export default LoginOAuthBB;
